import { CardData } from './card-data';
import { ProductType } from '../enum/dto/product-type.enum';
import { VariantType } from '../enum/dto/variant-type.enum';
import { exists } from '../../functions/exists';
import { VariantTypeUtils } from '../../utils/variant-type-utils';

export class JaneDoeCardData extends CardData {
  public override getSize(): string {
    const v = this.rowVariants?.firstOrNull();
    switch (true) {
      case ProductType.Seed === v?.productType || VariantType.Seed === v?.variantType: {
        return null;
      }
      case VariantTypeUtils.isPreRollType(v?.variantType): {
        const quantity = v?.packagedQuantity;
        const formattedUnitSize = v?.getFormattedUnitSize();
        const hasQty = Number.isFinite(quantity);
        const hasSize =
          exists(formattedUnitSize) &&
          formattedUnitSize !== '0' &&
          formattedUnitSize !== '-' &&
          formattedUnitSize !== '--';
        switch (true) {
          case hasQty && hasSize:
            return `${quantity} x ${formattedUnitSize}`;
          case hasQty && !hasSize:
            return `${quantity}`;
          default:
            return '-';
        }
      }
      case VariantTypeUtils.isCapsuleType(v?.variantType): {
        const n = v?.packagedQuantity ?? 0;
        if (n === 0) return '-';
        return `${n} cap`
          .pluralizer()
          .addRule({ isPlural: n > 1, useApostrophe: false, word: 'cap' })
          .pluralize();
      }
      case v?.productType === ProductType.Beverage && VariantTypeUtils.isReadyToDrinkBeverageType(v?.variantType): {
        const quantity = v?.packagedQuantity;
        const formattedUnitSize = v?.getFormattedUnitSize();
        return quantity === 1 ? `${formattedUnitSize}` : `${quantity} x ${formattedUnitSize}`;
      }
      case v?.productType === ProductType.Edible && !VariantTypeUtils.isReadyToDrinkBeverageType(v?.variantType): {
        return `${v?.packagedQuantity} pc`;
      }
      default: {
        return v?.getFormattedUnitSize();
      }
    }
  }

  getCardBorderColor(): string {
    const productsInfoBackgroundColor = this.getAccentColor();
    if (exists(productsInfoBackgroundColor)) return productsInfoBackgroundColor;
    return null;
  }

  public getBottomText(): string {
    const variantType = this.rowVariantType();
    switch (true) {
      /* Select following based off variant type */
      case variantType === VariantType.Baking:
        return 'Baked Goods';
      case variantType === VariantType.Capsule:
        return 'Capsules';
      case variantType === VariantType.Gummy:
        return 'Gummies';
      case variantType === VariantType.HardCandy:
        return 'Lozenges';
      case variantType === VariantType.Oil:
        return 'Oils';
      case variantType === VariantType.Edible:
        return 'Edibles';
      default:
        return variantType;
    }
  }
}
